var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalVSelect"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.pageTitle)))]),_c('v-select',{ref:"modalSelect",attrs:{"options":_vm.list,"value":_vm.val},on:{"input":_vm.updateFunction}},[_c('template',{slot:"no-options"},[_vm._v("\n            "+_vm._s(_vm.$t('sem-resultados-filtro'))+"\n        ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }